export default __webpack_public_path__ + "static/media/Rombit.805d4872.png";